import { createContext, useContext } from 'react';

/**
 * Set by the event workspace around its tabs. A page that also stands alone
 * (Guests, Timeline, Floor Plan, Task Lists…) reads it to drop its own "Back"
 * button, since the workspace header above it already says where you are.
 */
export const EventWorkspaceContext = createContext(false);

export function useInEventWorkspace(): boolean {
  return useContext(EventWorkspaceContext);
}
